import { api } from '../../services/api';
import * as types from '../Constants';

export const getLIANumber = () => {
  const options = {
    url: 'v1/users/UserLIAnumber',
  };
  options.types = [types.GET_LIA_NUMBER_SUCCESS, types.GET_LIA_NUMBER_FAILURE];

  return api.get(options);
};

export const updateLIANumber = (data) => {
  const options = {
    url: 'v1/users/UserLIAnumber',
  };
  options.types = [types.UPDATE_LIA_NUMBER_SUCCESS, types.UPDATE_LIA_NUMBER_FAILURE];

  return api.put(options, data);
};
